<template>
	<form action="" class="form" @submit.prevent="submit" novalidate="true">
		<div class="form-control">
			<label class="form-label">Электронная почта</label>
			<input v-model="login" class="form-input" type="text" name="email" ref="emailInput" />
			<label v-if="isValid && !login" class="error">Это поле обязательно</label>
			<label class="error" v-if="isValid && !idn">Не верный формат электронной почты</label>
		</div>
		<template v-if="isUser">
			<div class="form-control">
				<label class="form-label">Пароль</label>
				<input v-model="password" class="form-input" type="password" name="password" />
				<label v-if="isValid && password.length < 6" class="error">
					Минимальная длина пароля 6 символов
				</label>
				<nuxt-link to="/profile/reset" class="form-resetLink">Забыли пароль?</nuxt-link>
			</div>
			<div class="form-control text-center">
				<div class="form-buttons form-buttons_auth">
					<div class="form-buttonsItem">
						<div class="button" @click="doLogin"><span>Войти</span></div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="form-control" v-if="!!login">
				<label class="form-label">Ваше имя</label>
				<input v-model="name" class="form-input" type="text" name="name" />
				<label v-if="isValid && !name" class="error">Это поле обязательно</label>
			</div>
			<div class="form-control" v-if="!!name">
				<label class="form-label">Телефон</label>
				<phone-mask-input
					v-model="phone"
					wrapperClass="form-wrapper"
					inputClass="form-input"
					autoDetectCountry
				/>
				<label v-if="isValid && !phone" class="error">Это поле обязательно</label>
			</div>
			<div class="form-control text-center">
				<div class="form-buttons">
					<div class="form-buttonsItem">
						<div class="button" @click="submit"><span>Зарегистрироваться</span></div>
					</div>
				</div>
				<div class="form-buttons">
					<div class="form-buttonsItem">
						<socials :blankFrame="true" :noRedirect="true"></socials>
					</div>
				</div>
			</div>
		</template>
	</form>
</template>

<script>
import socials from '@/components/socials.vue';
import _ from 'lodash';

export default {
	components: { socials },
	data() {
		return {
			login: '',
			phone: '',
			name: '',
			isValid: false,
			timer: null,
			loading: false,
			isUser: false,
			password: '',
		};
	},
	computed: {
		valid() {
			return this.isUser
				? this.login && this.password && this.password.length >= 6
				: this.login && this.phone && this.name && this.idn;
		},
		idn() {
			var re = /^[-\w.]+@([А-яёA-z0-9][-А-яёA-z0-9]+\.)+[А-яёA-z]{2,6}$/;
			return re.test(this.login);
		},
	},
	methods: {
		submit() {
			this.isValid = true; //отображаем ошибки
			if (this.valid)
				this.$store
					.dispatch('api/send', {
						task: 'register',
						data: {
							login: this.login,
							phone: this.phone,
							name: this.name,
						},
					})
					.then(() => {
						if (this.$store.state.user.id) {
							this.$store.dispatch('checkPromo', this.$route);
						}
					});
		},
		/*clickSocialAuth(e) {
			let win = window.open(e.target.href, '_blank');
			let timer = setInterval(() => {
				window.$temp = win;
				console.log(win);
				if (!win) clearInterval(timer);
				win.opener = null;
			}, 500);
		},*/
		doLogin() {
			this.$store
				.dispatch('api/send', {
					task: 'login',
					data: {
						login: this.login,
						password: this.password,
					},
				})
				.then(() => {
					if (this.$store.state.user.id) {
						this.$store.dispatch('checkPromo', this.$route);
					}
				});
		},
	},
	mounted() {
		this.$refs.emailInput.focus();
		new Promise(resolve => {
			this.timer = setInterval(() => {
				this.$store
					.dispatch('api/send', {
						task: 'checkUserAuth',
					})
					.then(() => {
						if (this.$store.state.user.id) resolve();
					});
			}, 2000);
		});
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	watch: {
		login: _.debounce(function(value) {
			this.$store
				.dispatch('api/send', {
					task: 'checkUserEmail',
					data: {
						email: value,
					},
				})
				.then(mutations => {
					mutations.forEach(mutation => {
						if (mutation.name === 'local' && mutation.data) {
							this.isUser = mutation.data.isUser;
						}
					});
				});
		}, 500),
	},
};
</script>
